/**
 * Created by mohitbhansali on 10/06/18.
 */

export default class MusicProvider {

    static sharedProvider() {
        if (!MusicProvider.instance) {
            MusicProvider.instance = new MusicProvider();
        }
        return MusicProvider.instance;
    }

    configure(token) {
        window.MusicKit.configure({
            developerToken: token,
            app: {
                name: 'damusic',
                build: '0.0.1'
            }
        });
    }

    getMusicInstance() {
        return window.MusicKit.getInstance();
    }
}
